<template>
  <div class="columns is-multiline is-mobile is-centered">
    <div class="column is-full">
      <window title="Barchart">
        <div class="Chart">
          <bar-example/>
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Horizontal Barchart">
        <div class="Chart">
          <horizontal-bar-example/>
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Barchart with reactive mixing for live data">
        <div class="Chart">
          <reactive-example/>
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Barchart with reactive mixing for live data as props">
        <div class="Chart">
          <reactive-prop-example :chart-data="dataPoints" />
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Linechart">
        <div class="Chart">
          <line-example/>
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Doughnutchart">
        <div class="Chart">
          <doughnut-example/>
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Piechart">
        <div class="Chart">
          <pie-example/>
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Radarchart">
        <div class="Chart">
          <radar-example/>
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Polararea">
        <div class="Chart">
          <polar-area-example/>
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Bubblechart">
        <div class="Chart">
          <bubble-example />
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Scatter Chart">
        <div class="Chart">
          <scatter-example />
        </div>
      </window>
    </div>
    <div class="column is-full">
      <window title="Custom Line Chart">
        <div class="Chart">
          <custom-line />
        </div>
      </window>
    </div>
  </div>
</template>

<script>
import BarExample from 'vue-chartjs/src/examples/BarExample';
import DoughnutExample from 'vue-chartjs/src/examples/DoughnutExample';
import PieExample from 'vue-chartjs/src/examples/PieExample';
import RadarExample from 'vue-chartjs/src/examples/RadarExample';
import PolarAreaExample from 'vue-chartjs/src/examples/PolarAreaExample';
import BubbleExample from 'vue-chartjs/src/examples/BubbleExample';
import ReactiveExample from 'vue-chartjs/src/examples/ReactiveExample';
import ReactivePropExample from 'vue-chartjs/src/examples/ReactivePropExample';
import ScatterExample from 'vue-chartjs/src/examples/ScatterExample';
import HorizontalBarExample from 'vue-chartjs/src/examples/HorizontalBarExample';
import CustomLine from 'vue-chartjs/src/examples/CustomExample';
import LineExample from 'vue-chartjs/src/examples/LineExample';

export default {
  components: {
    BarExample,
    LineExample,
    DoughnutExample,
    CustomLine,
    PieExample,
    RadarExample,
    PolarAreaExample,
    BubbleExample,
    ReactiveExample,
    ReactivePropExample,
    ScatterExample,
    HorizontalBarExample,
  },
  data() {
    return {
      dataPoints: null,
      height: 20,
    };
  },
  mounted() {
    setInterval(() => {
      this.fillData();
    }, 2000);
  },
  methods: {
    increaseHeight() {
      this.height += 10;
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 + -5 + 1)) + 5;
    },
    fillData() {
      this.dataPoints = {
        labels: [`January${this.getRandomInt()}`, 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
        ],
      };
    },
  },
  computed: {
    myStyles() {
      return {
        height: `${this.height}px`,
        position: 'relative',
      };
    },
  },
};
</script>
